import React, { useEffect, useState } from 'react';
import '../../styles/CantoConversations.css';
import { FaChevronRight } from 'react-icons/fa';
import axiosPost from '../../helper/axios-helper';

export default function CantoConversations() {

    const [conversations, setConversations] = useState([]);
    const [upcomingConvo, setUpcomingConvo] = useState(null);

    useEffect(() => {
        fetchConversations();
        fetchNextUpcomingConversation();
    }, [])

    const fetchConversations = () => {
        axiosPost('conversations/fetch', {}, {}, (data) => {
            const { success, response } = data;

            if (success) {
                setConversations(data.data);
            } else {

            }
        });
    }

    const fetchNextUpcomingConversation = () => {
        axiosPost('conversations/next', {}, {}, (data) => {
            const { success, response } = data;

            if (success && data.data) {
                setUpcomingConvo(data.data);
                console.log('Upcoming:', data.data);
            } else {
                console.log('No upcoming conversation');
            }
        });
    }

    const renderConversations = () => {

        const render_conversations = conversations.map((convo, index) => {

            return (
                <div className='Convo'>
                    <div className='ConvoImage' style={{backgroundImage: `url(${convo.image})`}}></div>
                    <div className='ConvoInfo'>
                        <div className='ConvoInfoText'>
                            <div className='ConvoInfoTextTitle'>{convo.title}</div>
                            <div className='ConvoInfoTextSub'>{convo.subtitle}</div>
                        </div>

                        <a className='ConvoInfoBtn' href={convo.c2a} target='_blank'>Watch Now <FaChevronRight size={12} style={{marginLeft: '8px'}}/></a>
                    </div>
                </div>
            )

        })

        return render_conversations;

    }

  return (
    <div className='Conversations'>
        <div className='ConversationsBanner'>
            <div className='ConversationsBannerLogo' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/canto_convo_logo.png'})`}}></div>
            <div className='ConversationsBannerText'>
                CANTO Conversations emerged during the COVID-19 global pandemic as a vital platform to stay connected with our members amidst restrictions on movement across the Caribbean. While initially launched in response to the pandemic, its ongoing success has proven invaluable in facilitating the dissemination of information and maintaining meaningful connections beyond face-to-face events. If you are interested in hosting a CANTO Conversations, please contact our Business Support Officer, Mrs. Andrea Lewis-Francis at alewis@canto.org.
            </div>

            <div className='ConversationsBannerImage' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/convo_cover.png'})`}}></div>
        </div>

        {upcomingConvo && (
            <>
                <div className='ConversationsTitle'>Upcoming CANTO Conversations</div>
                <div className='ConversationsContainer'>
                    <div className='Convo'>
                        <div className='ConvoImage' style={{backgroundImage: `url(${upcomingConvo.image})`}}></div>
                        <div className='ConvoInfo'>
                            <div className='ConvoInfoText'>
                                <div className='ConvoInfoTextTitle'>{upcomingConvo.title}</div>
                                {upcomingConvo.timestamp && (
                                    <div style={{
                                        fontSize: '14px',
                                        color: '#40B6BF',
                                        fontWeight: '600',
                                        marginBottom: '10px',
                                        marginTop: '5px'
                                    }}>
                                        📅 {new Date(upcomingConvo.timestamp * 1000).toLocaleDateString('en-US', { 
                                            weekday: 'long',
                                            year: 'numeric', 
                                            month: 'long', 
                                            day: 'numeric'
                                        })} at {new Date(upcomingConvo.timestamp * 1000).toLocaleTimeString('en-US', { 
                                            hour: 'numeric', 
                                            minute: '2-digit',
                                            hour12: true
                                        })}
                                    </div>
                                )}
                                <div className='ConvoInfoTextSub'>{upcomingConvo.subtitle}</div>
                            </div>

                            <a className='ConvoInfoBtn' style={{background: '#40B6BF'}} href={upcomingConvo.c2a} target='_blank' rel='noopener noreferrer'>Register Now <FaChevronRight size={12} style={{marginLeft: '8px'}}/></a>
                        </div>
                    </div>
                </div>
            </>
        )}

        <div className='ConversationsTitle'>Previous CANTO Conversations</div>
        <div className='ConversationsContainer'>
            {renderConversations()}
        </div>
    </div>
  )
}
